import { render, staticRenderFns } from "./DownloadVacation2.vue?vue&type=template&id=5314a845&"
import script from "./DownloadVacation2.vue?vue&type=script&lang=ts&"
export * from "./DownloadVacation2.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadVacation2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DownloadVacation2.vue"
export default component.exports